/**
 * richText
 */

const richText = {
    cfg:  {
        name: '.a-richText p',
        pTags: '',
    },

    init() {
        this.cfg.pTags = [...document.querySelectorAll(this.cfg.name)];

        if (this.cfg.pTags) {
            this.cfg.pTags.forEach((pTag) => {
                pTag.setAttribute('lang', document.documentElement.lang);
            });
        }
    }
};

export default richText;



// WEBPACK FOOTER //
// ./___src/templates/_atoms/richText/_script.js